import { AIConversationType } from '../../../../../extViewmodels/sdk/models/AI';

/**
 * Maps AI conversation types to their corresponding assistant names used in API routes.
 * Based on backend assistant registrations.
 *
 * Note: Most assistants use their class name, but some have explicit overrides:
 * - SalesLiveCoachingAgent → "SalesLiveCoachingAssistant"
 * - CustomAgent → "Custom"
 */
export function getAssistantNameFromConversationType(conversationType: AIConversationType): string {
	switch (conversationType) {
		// Sales coaching assistants
		case AIConversationType.SalesPreCallCoaching:
			return 'SalesPreCallAgent';
		case AIConversationType.SalesPostCallCoaching:
			return 'SalesPostCallCoachingAgent';
		case AIConversationType.SalesDemoCallCoaching:
			return 'SalesDemoCallCoachingAgent';
		case AIConversationType.SalesLiveCoaching:
			return 'SalesLiveCoachingAssistant'; // Exception: uses "Assistant" suffix
		case AIConversationType.SalesPracticeCall:
			return 'SalesPracticeCallAgent';

		// Other assistants
		case AIConversationType.SuccessMeetingPrep:
			return 'SuccessMeetingPrepAgent';
		case AIConversationType.SiteWide:
			return 'SiteWideAgent';
		case AIConversationType.BlogGeneration:
			return 'BlogGenerationAgent';
		case AIConversationType.EmailContentGeneration:
			return 'EmailContentGenerationAgent';
		case AIConversationType.SocialMediaContentGeneration:
			return 'SocialMediaContentGenerationAgent';
		case AIConversationType.GoogleReviewReply:
			return 'GoogleBusinessReviewReplyAgent';
		case AIConversationType.Admin:
			return 'Custom'; // Exception: uses "Custom" instead of class name

		// Fallback: append "Agent" to conversation type (may not work for all types)
		default:
			return `${conversationType}Agent`;
	}
}
